import { createSlice } from "@reduxjs/toolkit";
import { fetchKycStatus, fetchKycLink, saveBankDetails } from "./KycThunk";
import { status } from "../../_constants/common";

const KYCSlice = createSlice({
    name: "kyc",
    initialState: {
        // KYC status response from API
        kycStatus: {
            status: null,
            data: null,
        },
        // KYC onboarding link
        kycLink: {
            status: null,
            data: null,
        },
        // Bank details save result
        bankDetailsSave: {
            status: null,
            data: null,
        },
    },
    reducers: {
        clearKycStatus: (state) => {
            state.kycStatus = { status: null, data: null };
        },
        clearKycLink: (state) => {
            state.kycLink = { status: null, data: null };
        },
        clearBankDetailsSave: (state) => {
            state.bankDetailsSave = { status: null, data: null };
        },
    },
    extraReducers: (builder) => {
        builder
            // Fetch KYC Status
            .addCase(fetchKycStatus.pending, (state) => {
                state.kycStatus = {
                    status: status.IN_PROGRESS,
                    data: state.kycStatus.data, // keep stale data during refetch
                };
            })
            .addCase(fetchKycStatus.fulfilled, (state, { payload }) => {
                state.kycStatus = {
                    status: status.SUCCESS,
                    data: payload,
                };
            })
            .addCase(fetchKycStatus.rejected, (state, { payload }) => {
                state.kycStatus = {
                    status: status.FAILURE,
                    data: payload,
                };
            })

            // Fetch KYC Link
            .addCase(fetchKycLink.pending, (state) => {
                state.kycLink = {
                    status: status.IN_PROGRESS,
                    data: null,
                };
            })
            .addCase(fetchKycLink.fulfilled, (state, { payload }) => {
                state.kycLink = {
                    status: status.SUCCESS,
                    data: payload,
                };
            })
            .addCase(fetchKycLink.rejected, (state, { payload }) => {
                state.kycLink = {
                    status: status.FAILURE,
                    data: payload,
                };
            })

            // Save Bank Details
            .addCase(saveBankDetails.pending, (state) => {
                state.bankDetailsSave = {
                    status: status.IN_PROGRESS,
                    data: null,
                };
            })
            .addCase(saveBankDetails.fulfilled, (state, { payload }) => {
                state.bankDetailsSave = {
                    status: status.SUCCESS,
                    data: payload,
                };
            })
            .addCase(saveBankDetails.rejected, (state, { payload }) => {
                state.bankDetailsSave = {
                    status: status.FAILURE,
                    data: payload,
                };
            });
    },
});

export const { clearKycStatus, clearKycLink, clearBankDetailsSave } = KYCSlice.actions;
export default KYCSlice.reducer;
